module.exports = __webpack_public_path__ + "static/media/kneecap-up-1.437d4620.png";